<template>
  <div class="app-user-not-login-password">
    <userPassword></userPassword>
  </div>
</template>

<script>
import UserPassword from '../password/App.vue'

export default {
  name: 'not-login-password',
  components: {
    UserPassword
  }
}
</script>
